import { useEffect, useState } from "react";

export default function MusicDemoPlayer({ title, artist }: { title: string; artist: string }) {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!playing) return;
    const timer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 0 : prev + 1));
    }, 300);
    return () => clearInterval(timer);
  }, [playing]);

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-100 p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-music-2-line text-primary-500" />
          <span className="font-label text-sm font-semibold text-foreground-900">作品试听（演示）</span>
        </div>
        <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs font-medium text-accent-700">
          演示界面
        </span>
      </div>

      <div className="mt-4 flex items-center gap-4">
        <button
          type="button"
          onClick={() => setPlaying((v) => !v)}
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
          aria-label={playing ? "暂停" : "播放"}
        >
          <i className={playing ? "ri-pause-fill text-2xl" : "ri-play-fill text-2xl"} />
        </button>
        <div className="min-w-0 flex-1">
          <p className="truncate font-heading text-sm font-bold text-foreground-950">{title}</p>
          <p className="truncate text-xs text-foreground-500">{artist}</p>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-300">
            <div
              className="h-full rounded-full bg-primary-500 transition-all"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="mt-1 flex justify-between text-[11px] text-foreground-400">
            <span>{`0:${String(Math.floor((progress * 3.6) / 60)).padStart(1, "0")}`}</span>
            <span>3:36</span>
          </div>
        </div>
      </div>
      <p className="mt-3 text-xs text-foreground-500">
        提示：本站试听为前端演示效果，暂未接入真实音频数据。
      </p>
    </div>
  );
}